import {
  useGetAddressesByBusinessPartnerId,
  useGetBusinessPartnerById,
  useGetContactEmployeesByBusinessPartnerId,
} from '@/api/business-partner/business-partner.hooks.ts';
import { AdjustPricelistDialog } from '@/components/dialogs/adjust-pricelist.dialog';
import { ChangePasswordDialog } from '@/components/dialogs/change-password.dialog';
import { useGlobalStore } from '@/stores';
import { Divider, Grid } from '@mui/material';
import { useDialogs } from '@components/dialogs/dialogs-provider';
import { ActionButtons } from './action-buttons.component';
import { AddressInformation } from './address-information.component';
import { CompanyInformation } from './company-information.component';
import { ContactInformation } from './contact-information.component';

export function MyDataComponent() {
  const store = useGlobalStore();
  const dialogs = useDialogs();
  const { contactEmployeeId, businessPartnerId } = store;

  const { data: businessPartner, isPending: isBusinessPartnerPending } =
    useGetBusinessPartnerById(Number(businessPartnerId));
  const { data: contactEmployees, isPending: isContactEmployeesPending } =
    useGetContactEmployeesByBusinessPartnerId(Number(businessPartnerId));
  const { data: addresses, isPending: isAddressesPending } =
    useGetAddressesByBusinessPartnerId();

  const defaultBillingAddress = addresses?.find(
    (address) => address.addressType === 'bo_BillTo',
  );
  const defaultShippingAddress = addresses?.find(
    (address) => address.addressType === 'bo_ShipTo',
  );
  const contactEmployee = contactEmployees?.find(
    (employee) => employee.id === contactEmployeeId,
  );

  const handleOpenChangePasswordDialog = async () => {
    await dialogs.open(ChangePasswordDialog);
  };

  const handleOpenAdjustPricelistDialog = async () => {
    await dialogs.open(AdjustPricelistDialog);
  };

  const isLoading = isContactEmployeesPending || isBusinessPartnerPending;

  return (
    <Grid sx={{ width: "100%" }} container>
      <Grid size={{ xs: 12, md: 6 }}>
        <ContactInformation
          contactEmployee={contactEmployee}
          isLoading={isLoading}
        />
        <ActionButtons
          onChangePassword={handleOpenChangePasswordDialog}
          onAdjustPricelist={handleOpenAdjustPricelistDialog}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <CompanyInformation
          contactEmployee={contactEmployee}
          isLoading={isLoading}
        />
      </Grid>
      <Divider sx={{ height: 2, width: '100%', mt: 2 }} />
      <AddressInformation
        defaultBillingAddress={defaultBillingAddress}
        defaultShippingAddress={defaultShippingAddress}
        isLoading={isAddressesPending}
      />
    </Grid>
  );
}
